import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
    token!: string;
  role!: string;

  password = '';
  confirmPassword = '';

  passwordError: string | null = null;
  confirmPasswordError: string | null = null;
  validationError: string | null = null;
  isTokenValid: boolean = false

   constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService){

    }

ngOnInit(): void {
  this.token = this.route.snapshot.paramMap.get('token')!;
  this.role = this.route.snapshot.paramMap.get('role')!;

  this.authService.verifyResetToken(this.token, this.role).subscribe({
    next: () => {
      this.isTokenValid = true;
    },
    error: () => {
      this.isTokenValid = false;
      sweetAlert('Error', 'Reset link expired or invalid', 'error', 'OK');
      this.router.navigateByUrl('/forgot-password');
    }
  });
}


  validatePassword(): void {
    if (!this.password) {
      this.passwordError = 'New Password is required.';
    } else if (this.password.length < 8) {
      this.passwordError = 'Password must be at least 8 characters.';
    } else {
      this.passwordError = null;
    }
  }

  validateConfirmPassword(): void {
    if (!this.confirmPassword) {
      this.confirmPasswordError = 'Confirm Password is required.';
    } else {
      this.confirmPasswordError = null;
    }

    if (this.password && this.confirmPassword && this.password !== this.confirmPassword) {
      this.validationError = 'Passwords do not match.';
    } else {
      this.validationError = null;
    }
  }

  onSubmit(): void {
    this.validatePassword();
    this.validateConfirmPassword();

    if (this.passwordError || this.confirmPasswordError || this.validationError) {
      return;
    }

    const payload = {
      newPassword: this.password,
      verifyPassword: this.confirmPassword
    };

    this.authService
      .resetPassword(this.token, this.role, payload)
      .subscribe({
        next: () => {
          sweetAlert('Success', 'Password reset successfully!', 'success', 'OK');
          this.router.navigateByUrl('/login');
        },
        error: (err) => {
          sweetAlert(
            'Error',
            err.error.message || 'Reset link expired or invalid',
            'error',
            'OK'
          );
        }
      });
  }

}
